// extracted by mini-css-extract-plugin
export var bottomRightDecoration = "S_dv";
export var carouselRow = "S_dq";
export var description = "S_dx";
export var image = "S_g";
export var imageWrapper = "S_ds";
export var navButton = "S_dr";
export var section = "S_d";
export var textWrapper = "S_dz";
export var title = "S_h";
export var topLeftDecoration = "S_dt";